import React from 'react'

import classNames from 'classnames'

import SelectRoleWrapper from 'components/Utils/SelectRole/Wrapper'
import UserRow from 'components/Users/UserRow'
import UserGroupRow from 'components/UserGroups/UserGroupRow'

import {
  rolesMap as userRolesMap,
  rolesMapPluralized as groupRolesMap,
} from 'remote/channels/roles'

export type MembershipRowProps = {
  item: any
  onSelection: (args: { item: any; role: string }) => void
}
export default function MembershipRow({
  item,
  onSelection,
}: MembershipRowProps) {
  const [popoverIsOpen, setPopoverIsOpen] = React.useState(false)
  return (
    <SelectRoleWrapper
      roles={item.type === 'User' ? userRolesMap : groupRolesMap}
      onSelectRole={(role: string) => onSelection({ item, role })}
      position="bottom"
      align="end"
      onIsOpenChange={({ isOpen }: { isOpen: boolean }) =>
        setPopoverIsOpen(isOpen)
      }
    >
      <div
        className={classNames(
          'flexbox flexbox-align-center padding-horizontal-medium pointer transition background-shade-50-on-hover',
          popoverIsOpen && 'background-shade-50'
        )}
        style={{ height: 40, marginTop: 2, marginBottom: 2 }}
      >
        <div>
          {item.type === 'User' ? (
            <UserRow user={item.user} />
          ) : (
            <UserGroupRow userGroup={item.userGroup} />
          )}
        </div>
      </div>
    </SelectRoleWrapper>
  )
}
